import { render, staticRenderFns } from "./PurchaseBackList.vue?vue&type=template&id=2bb4cac4&scoped=true"
import script from "./PurchaseBackList.vue?vue&type=script&lang=js"
export * from "./PurchaseBackList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseBackList.vue?vue&type=style&index=0&id=2bb4cac4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4cac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb4cac4')) {
      api.createRecord('2bb4cac4', component.options)
    } else {
      api.reload('2bb4cac4', component.options)
    }
    module.hot.accept("./PurchaseBackList.vue?vue&type=template&id=2bb4cac4&scoped=true", function () {
      api.rerender('2bb4cac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/PurchaseBackList.vue"
export default component.exports